import React, { useState, useEffect } from 'react'

// css
import 'assets/style/elements/calendar-select.scss'

function Element({ text, className }) {
  return (
    <>
      <ul className="calendar-select">
        <li>
          <div className="week-area">
            <span className="week">월</span>

            {/* 휴일인 경우 event 클래스 추가 */}
            <span className="day f-roboto event">25</span>
          </div>
          <span className="event-text">크리스마스</span>
        </li>
        <li>
          <div className="week-area">
            <span className="week">화</span>
            <span className="day f-roboto">26</span>
          </div>
        </li>

        {/* 선택된 날짜 li에 active 클래스 추간 */}
        <li className="active">
          <div className="week-area">
            <span className="week">수</span>
            <span className="day f-roboto">27</span>
          </div>
        </li>
        <li>
          <div className="week-area">
            <span className="week">목</span>
            <span className="day f-roboto">28</span>
          </div>
        </li>
        <li>
          <div className="week-area">
            <span className="week">금</span>
            <span className="day f-roboto">29</span>
          </div>
        </li>
        <li>
          <div className="week-area">
            <span className="week">토</span>
            <span className="day f-roboto">30</span>
          </div>
        </li>
        <li>
          <div className="week-area">
            <span className="week">일</span>
            <span className="day f-roboto event">31</span>
          </div>
        </li>
      </ul>
    </>
  )
}

export default Element
